import { useTheme } from "styled-components";
import Link from "../../../../../../componentReusable/Link";
import { getIntegrationLink } from "helpers/links-builders/loggedInLinks";
import { localize } from "utils/misc/localize";
import { FC } from "react";
import {classNames} from "helpers/themeHelpers";
import { gtmAddYourAdPostBtn,gtmBannarBuyNowBtn } from "GTMs/actions/homeActions";
import { linkToFind } from "helpers/links-builders/listing";
import Image from "../../../../../../componentReusable/Image";
import useGetRouteCity from "../../../../../../hooks/useGetRouteCity";
import { AddPostProvider } from "../../../../../../componentReusable/Providers/AddPostProvider";
import { handleLoggingInLandingPages } from "componentScreens/LandingPages/Comps/CategoryLandingCommon/CategoryLandingCommon";
import {useGetRoutesObjects} from "contexts/RoutesObjectContext";
import {EnumIntegrationEvent} from "../../../../../../enums/EnumIntegrationEvent";
import {EnumWidgets} from "../../../../../../libs/logging/types/loggingTypes";
import {HomeBannerTwoCont, HomeBannerTwoMiddle} from "./homeBannerTwo.styled";

const HomeBannerTwo: FC = () => {
  const { translations, isDesktop, isMobile } = useTheme();
  const city = useGetRouteCity();
  const {category } = useGetRoutesObjects()
  return (
    <HomeBannerTwoCont
      id="homeBannerTwo"
      {...classNames(
        "grayBg center",
        isDesktop && "mb-32",
      )}
    >
      <div  {...classNames(
        isDesktop && "absolute grayBg pt-32 pb-32"
      )}>
        <div
          {...classNames(
            "flex m-auto",
            isMobile && "flexDirectionColumn gap-20 p-16 radius-8 whiteBg",
            isDesktop && "width-1200"
          )}
        >
          <div
            {...classNames(
              "flex flexDirectionColumn justifyContent alignItems wrapperImg",
              isDesktop && "width-33",
              isMobile && "font-20"
            )}
          >
          <span className="block mb-16 bold">
              {translations.snapadvertiseSell}
          </span>
            <Image
              src={`/images/homePage/homeBanner-1.webp`}
              alt={translations.addyouradNow}
              width="100%"
              height="100%"
              loading="lazy"
            />
            <AddPostProvider
              gtmAction={gtmAddYourAdPostBtn}
              iframeUrl={getIntegrationLink(EnumIntegrationEvent.ADD_POST)}
              widgetName={EnumWidgets.ADD_LISTING_SIMILAR}
              render={({ onClickCb }) => (
                <button
                  {...classNames("orangeBtn p-16 mt-16 width-100")}
                  onClick={onClickCb}
                >
                  {translations.addyouradNow}
                </button>
              )}
            />
          </div>
          <HomeBannerTwoMiddle
            {...classNames(
              "flex flexDirectionColumn alignSelfCenter",
              isDesktop && "width-33"
            )}
          >
            <div
              {...classNames(
                "mb-16",
                isDesktop && "whiteBg",
                isMobile && "mb-16 grayBg"
              )}
            >
            <span className="block  bold pb-16">
              {localize(translations.millionVisitor, ["60"])}
            </span>
              {translations.userLang}
            </div>
            <div
              {...classNames(
                "p-16",
                isDesktop && "whiteBg",
                isMobile && "mb-16 grayBg"
              )}
            >
              <span className="block bold mb-32">{translations.bestPrices}</span>
              {translations.addAdsEarnFaster}
            </div>
          </HomeBannerTwoMiddle>
          <div
            {...classNames(
              "flex flexDirectionColumn justifyContent alignItems wrapperImg",
              isDesktop && "width-33",
              isMobile && "font-20"
            )}
          >
          <span className="blueColor block mb-16 bold">
            {translations.searchSellBuy}
          </span>
            <Image
              src={`/images/homePage/homeBanner-2.webp`}
              alt={translations.addyouradNow}
              width="100%"
              height="100%"
              loading="lazy"
            />
            <Link
              href={linkToFind({ cities: [city] })}
              onClick={()=>{
              gtmBannarBuyNowBtn();
              handleLoggingInLandingPages({category:category , city:city?.name_english})
            }}
            >
              <a className="blueBtn p-16 mt-16 width-100" id="searchNowBtnSource">
                {translations.searchNow}
              </a>
            </Link>
          </div>
        </div>
      </div>
    </HomeBannerTwoCont>
);
};

export default HomeBannerTwo;
